(() => {
  const sectionSelector = '#MainContent > .shopify-section';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const designMode = Boolean(window.Shopify && window.Shopify.designMode);
  let observer;

  const isEligible = (section) =>
    !section.classList.contains('scroll-reveal-disabled') && section.dataset.scrollReveal !== 'off';

  const reveal = (section) => {
    section.classList.add('is-revealed');
    observer?.unobserve(section);
  };

  const createObserver = () => {
    if (designMode || reducedMotion.matches || !('IntersectionObserver' in window)) return null;

    return new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) reveal(entry.target);
        });
      },
      {
        threshold: 0.08,
        rootMargin: '0px 0px -8% 0px',
      }
    );
  };

  const prepare = (section) => {
    if (!(section instanceof HTMLElement) || !isEligible(section)) return;

    section.classList.add('scroll-reveal-section');

    if (designMode || reducedMotion.matches || !observer) {
      reveal(section);
      return;
    }

    const bounds = section.getBoundingClientRect();
    const isInitiallyVisible = bounds.top < window.innerHeight * 0.92 && bounds.bottom > 0;

    if (isInitiallyVisible) {
      reveal(section);
    } else {
      observer.observe(section);
    }
  };

  const prepareSections = (root = document) => {
    if (root instanceof HTMLElement && root.matches(sectionSelector)) prepare(root);
    root.querySelectorAll?.(sectionSelector).forEach(prepare);
  };

  const revealEverything = () => {
    observer?.disconnect();
    observer = null;
    document.querySelectorAll('.scroll-reveal-section').forEach(reveal);
  };

  const initialize = () => {
    observer = createObserver();
    prepareSections();

    // The enabling class is added last so content stays visible if setup fails.
    requestAnimationFrame(() => document.documentElement.classList.add('scroll-reveal-enabled'));

    document.addEventListener('shopify:section:load', (event) => prepareSections(event.target));
    reducedMotion.addEventListener?.('change', (event) => {
      if (event.matches) revealEverything();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
